import React, { useEffect, useState } from 'react'

const Scripts = () => {
    const [active, setActive] = useState(false)

    const events = [
        'keypress', 'mousemove', 'touchstart', 'touchmove', 'click', 'scroll'
    ]

    // const googleTag = () => {
    //     const mainScript = document.createElement('script')
    //     mainScript.setAttribute('id', "gtag-init")
    //     mainScript.setAttribute('async', 'true')
    //     mainScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-1X6282J7KK')
    //     if (!document.getElementById('gtag-init'))
    //         document.head.appendChild(mainScript)

    //     const script = document.createElement('script')
    //     script.setAttribute('id', "gtag-script")
    //     script.innerHTML = `window.dataLayer = window.dataLayer || [];
    //     function gtag(){dataLayer.push(arguments);}
    //     gtag('js', new Date());
      
    //     gtag('config', 'G-1X6282J7KK');`
    //     if (!document.getElementById('gtag-script'))
    //         document.head.appendChild(script)
    // }

    // const universalAnalytics = () => {
    //     const mainScript = document.createElement('script')
    //     mainScript.setAttribute('id', "ua-init")
    //     mainScript.setAttribute('async', 'true')
    //     mainScript.setAttribute('src', "https://www.googletagmanager.com/gtag/js?id=UA-253208571-1")
    //     if (!document.getElementById('ua-init'))
    //         document.head.appendChild(mainScript)

    //     const script = document.createElement('script')
    //     script.setAttribute('id', "ua-script")
    //     script.innerHTML = `window.dataLayer = window.dataLayer || [];
    //     function gtag(){dataLayer.push(arguments);}
    //     gtag('js', new Date());
      
    //     gtag('config', 'UA-253208571-1');`
    //     if (!document.getElementById('ua-script'))
    //         document.head.appendChild(script)
    // }

    const gtm = () => {
        const script = document.createElement('script')
        script.setAttribute('id', "gtm")
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-52DB9VC');`
        if (!document.getElementById('gtm'))
            document.head.appendChild(script)
    }

    const handleEvent = () => {
        setActive(true)
        // googleTag()
        // universalAnalytics()
        gtm()
        // zendesk()
        // zendeskFormHide()
        events.forEach((event) => window.removeEventListener(event, handleEvent))
    }

    useEffect(() => {
        events.forEach((event) => window.addEventListener(event, handleEvent))
    }, [])

    setTimeout(() => {
        !active && handleEvent()
    }, 6000)

    return (
        <></>
    )
}

export default Scripts